<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
        <Tabs v-if="data.isLoadDefaultFormDone" v-model:activeKey="data.tabKey" type="card">
            <TabPane key="CancelSequestrateInfo" :tab="$t('views.request.cancelSequestrateInfo.title')" :forceRender="true">
                <CancelSequestrateInfoForm
                        :menuContext="menuContext"
                        :viewOnly="viewOnly"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></CancelSequestrateInfoForm>
            </TabPane>
            <TabPane key="Attachment" :tab="$t('views.request.attachment.title')" :forceRender="true">
                <AttachmentForm
                        :menuContext="menuContext"
                        :viewOnly="true"
                        :dataProp="data"
                        :isLoading="isLoading"
                ></AttachmentForm>
            </TabPane>
        </Tabs>
        <ChangeLogCollapse
                class="mt-2"
                v-if="visibleChangeLog && data.id"
                :id="data.id"
                :onCallChangeLog="({ id, page, size }) => onCallChangeLog({ id, page, size, createSearchOneCriteria, callChanges })"
                :mappings="data.fieldLogs"
        ></ChangeLogCollapse>
    </Card>
</template>

<script>
    import { Card, Form, Tabs } from "ant-design-vue";
    import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
    import { useRoute } from "vue-router";
    import { state as stateApp } from "../../../../../app.logic";
    import { onCallChangeLog } from "../../../../../utils/form";
    import {
        callChanges,
        createFormTitle,
        createSearchOneCriteria,
        initForm,
        isLoading,
        onClickModalOk,
        state
    } from "./cancel-sequestrate.logic";

    export default defineComponent({
        components: {
            Card,
            Form,
            Tabs,
            TabPane: Tabs.TabPane,
            TemplateBuilder: defineAsyncComponent(() => import("../../../../../components/input/template-builder/TemplateBuilder")),
            AttachmentForm: defineAsyncComponent(() => import("../../../storage-location/request/attachment/AttachmentForm")),
            CancelSequestrateInfoForm: defineAsyncComponent(() => import("../request/cancel-sequestrate-info/CancelSequestrateInfoForm")),
            ChangeLogCollapse: defineAsyncComponent(() => import("../../../../../components/change-log/ChangeLogCollapse"))
        },
        props: {
            menuContext: { default: () => stateApp.menuContext },
            routerPrefix: { default: "cancel-sequestrates" },
            viewOnly: { default: false },
            form: {},
            setAppPageHeader: { default: true },
            visibleChangeLog: { default: true }
        },
        setup(props) {
            const route = useRoute();
            const id = props.form ? props.form.id : route.params?.id;
            const data = reactive({ rowProp: { gutter: 24 }, id, fieldLogs: [] });
            const refs = reactive({ form: null });
            initForm({ props, data, refs, route });
            const callOnClickModalOk = () => onClickModalOk({ data, refs });
            const title = computed(() => createFormTitle({ data }));
            return {
                props,
                data,
                refs,
                state,
                title,
                isLoading,
                callChanges,
                callOnClickModalOk,
                createSearchOneCriteria,
                onCallChangeLog
            };
        }
    });
</script>
